import React, { Component } from 'react';
import { Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem,
    Nav, NavItem, Button, Modal, ModalHeader,
    ModalBody, Label, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Loading } from './LoadingComponent';
import { CreateParagraphs } from './ReviewdetailComponent.js';
import ChessDraggable from './ChessDraggableComponent';
import ChessControls from './ChessControlsComponent';
//import { updateNumberRight/*, fetchNumberRight*/, updateNumberWrong, resetMoveIndex} from '../redux/ActionCreators';
import { connect } from 'react-redux';

    /*const mapStateToProps = state => {
      return {
        comboResults: state.comboResults
      }
    }

    const mapDispatchToProps = dispatch => ({
        resetMoveIndex: (moveIndex) => { dispatch(resetMoveIndex(moveIndex))}
      });*/

    class ComboDetail extends React.Component{
      constructor(props) {
         super(props);

         this.state = { index: 0, squareColor: 'green', pieceType: 'solid', comment: props.combo.comments[0], flipBoard: props.combo.flip, numberRight: 0, numberWrong: 0};
         // todo: if I set pieceType to image, pieces don't show up when board is not flipped.
         this.handleInputChange = this.handleInputChange.bind(this);
      }

      handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({
          flipBoard: value
        });
      }

    getPrevious(id, max, min){
      if(id == min){
        return max;
      }
      return id - 1;
    }

    getNext(id, max, min){
      if(id == max){
        return min;
      }
      return id + 1;
    }

    updateStateCommentFromChild = (index, comment, numberRight, numberWrong) => {

      this.setState({
        comment: comment,
        index: index,
        numberRight: numberRight,
        numberWrong: numberWrong
      })
    }

      render(){
        if (this.props.isLoading) {
            return(
                <div className="container">
                    <div className="row">
                        <Loading />
                    </div>
                </div>
            );
        }
        else if (this.props.errMess) {
            return(
                <div className="container">
                    <div className="row">
                        <h4>{this.props.errMess}</h4>
                    </div>
                </div>
            );
        }
        else if(this.props.combo != null)
        {
              return (
              <div className="container">
                <div className="row">
                    <Link to={`/combos/${this.getPrevious(this.props.combo.id, this.props.max, this.props.min)}`}>
                      <button class="btn btn-primary">
                         Previous Combination
                      </button>
                    </Link>
                    <Breadcrumb>
                        <BreadcrumbItem><Link to="/combos">Combos</Link></BreadcrumbItem>
                        <BreadcrumbItem active>{this.props.combo.name}</BreadcrumbItem>
                    </Breadcrumb>
                    <Link to={`/combos/${this.getNext(this.props.combo.id, this.props.max, this.props.min)}`}>
                      <button class="btn btn-primary">
       		               Next Combination
       		            </button>
                    </Link>
                    <div className="col-12">
                        <h3>{this.props.combo.name}</h3>
                        <hr />
                    </div>
                </div>
                <div className="row">
                    <div>
                        <CreateParagraphs description={this.props.combo.description}/>
                    </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md m-1">
                    <ChessDraggable fen={this.props.combo.diagrams[this.state.index]} comments={this.props.combo.comments} solution={this.props.combo.solution} squareColor={this.state.squareColor} pieceType={this.state.pieceType} updateStateCommentFromChild = {this.updateStateCommentFromChild} moveIndex={this.state.index} flipBoard={this.state.flipBoard} numberRight={this.state.numberRight} numberWrong={this.state.numberWrong} />
                  </div>
                </div>
                <div className="row">
                    <div>
                        <p>{this.state.comment}</p>
                    </div>
                </div>
                <div className="row">
                  <label>
                    Flip Board:
                    <input
                      name="flipBoard"
                      type="checkbox"
                      checked={this.state.flipBoard}
                      onChange={this.handleInputChange} />
                  </label>
                </div>
                <Card>
    		            {<CardBody>
    		              <CardTitle>Your Score</CardTitle>
                                  <p>{`Number right: ${this.state.numberRight}.`}</p>
                                  <p>{`Number wrong: ${this.state.numberWrong}.`}</p>
    		            </CardBody>}
    		        </Card>
              </div>
            );
        }
        else
      		return (
      		   <div></div>
      		);
      }
    }

export default ComboDetail;
//export default connect(mapStateToProps, mapDispatchToProps)(ComboDetail);
